class FetchAiCostLimitUsers {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAiCostLimitUsers;
